import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  template: `
    <div class="admin-actions-renderer">
      <span
          v-b-tooltip title="Вход"
          class="adminAction fas fa-eye text-primary text-center"
          @click="onLoginClicked"
      ></span>
      <span
          v-b-tooltip title="Редактировать"
          class="adminAction fas fa-edit text-primary text-center"
          @click="onEditClicked"
      ></span>
      <span
          v-b-tooltip title="Сбросить пароль"
          class="adminAction fas fa-redo-alt text-dark text-center"
          @click="onResetClicked"
      ></span>
      <span
          v-if="currentUser.id !== params.data.id"
          v-b-tooltip title="Удалить"
          class="adminAction fas fa-times text-danger text-center"
          @click="onDeleteClicked"
      ></span>
    </div>
  `,
  data() {
    return {}
  },
  computed: {
    ...mapGetters('currentUser', {
      currentUser: 'getCurrentUser'
    })
  },
  methods: {
    onEditClicked() {
      this.params.context.componentParent.onParentEditClicked(this.params.node.data)
    },
    onDeleteClicked() {
      this.params.context.componentParent.onParentDeleteClicked(this.params.node.data)
    },
    onResetClicked() {
      this.params.context.componentParent.onParentResetClicked(this.params.node.data)
    },
    onLoginClicked() {
      this.params.context.componentParent.onParentLoginClicked(this.params.node.data)
    }
  }
})
